<template>
  <div class="ndj-share-wrap">
    <img src="@/assets/image/ndjShare/1.png" alt="" class="img" />
    <img src="@/assets/image/ndjShare/2.png" @click="toPage" alt="" class="btn" />
  </div>
</template>
<script>
  export default {
    name: 'ndj-share',
    data() {
      return {};
    },
    mounted() {},
    methods: {
      toPage() {
        window.location.href = 'https://jinshuju.net/f/J74y75';
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ndj-share-wrap {
    background: #ffe9be;
    position: relative;
    .img {
      width: 100%;
    }
    .btn {
      width: 90%;
      position: absolute;
      left: 50%;
      bottom: 20px;
      -webkit-transform: translate3d(-50%, 0, 0);
      -moz-transform: translate3d(-50%, 0, 0);
      -ms-transform: translate3d(-50%, 0, 0);
      transform: translate3d(-50%, 0, 0);
    }
  }
</style>
